import { Controllers } from 'lib/enums/routes/_controllers';
import { UsersRoutes } from 'lib/enums/routes/users';
import { UserDoc, UserWhole } from 'lib/interfaces/database/user';
import { BaseService } from 'services/_base';

export class UsersService extends BaseService {
  private static instance: UsersService;

  static getInstance(): UsersService {
    if (!UsersService.instance) {
      UsersService.instance = new UsersService();
    }

    return UsersService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.users,
    });
  }

  search(payload: Partial<UserDoc>) {
    return this.POST(
      {
        uri: UsersRoutes.Search,
      },
      payload
    )
      .then((result: UserWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<UserDoc>) {
    return this.POST(
      {
        uri: UsersRoutes.CreateOne,
      },
      payload
    )
      .then((result: UserWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<UserDoc>) {
    return this.PUT(
      {
        uri: `${UsersRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: UserWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  // profile changes (e.g. name, email)
  updateSelf(payload: Partial<UserDoc>) {
    return this.PUT(
      {
        uri: UsersRoutes.UpdateSelf,
      },
      payload
    )
      .then((result: UserWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
